module.exports = __webpack_public_path__ + "img/scooba.d394723f.jpg";